<template>
    <div class="coupon-list-page">
        <navBar @onClickLeft="onClickLeft" title="优惠券" />
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <div  v-if="!myCouponList.length && !reCommendList.length" class="empty-box">
                <empty description="暂无优惠券" />
            </div>
            <div class="main" v-else>
                <!-- 已领优惠券 -->
                <div class="list-box" v-if="myCouponList.length" :class="{noborder: !reCommendList.length}">
                    <div :class="{hidden: myCouponList.length > 4 && !showMore}">
                        <couponItem 
                            v-for="item in myCouponList" 
                            :key="item.couponId" 
                            :data="item" 
                            @useCoupon="handleUse"
                            @getCoupon="getCoupon" 
                        />
                    </div>
                    <div class="more-box" v-if="myCouponList.length > 4">
                        <span @click="showMore = !showMore">{{showMore?'收起全部':'展开全部'}} <i class="icon" :class="{up: showMore}"></i></span>
                    </div>
                </div>
                <div v-else>
                    <empty description="暂无优惠券，赶快领取吧"/>
                </div>
                <!-- 推荐 -->
                <p class="title" v-if="reCommendList.length"><span class="text">获取更多优惠</span></p>
                <div class="list-box">
                    <couponItem 
                        v-for="item in reCommendList" 
                        :status="2"
                        :key="item.couponId" 
                        :data="item" 
                        @useCoupon="handleUse"
                        @getCoupon="getCoupon" 
                    />
                </div>
            </div>
        </van-pull-refresh>
    </div>
</template>
<script>
import {Toast} from 'vant';
import navBar from '../components/navBar.vue';
import couponItem from '../components/couponItem.vue';

export default {
    components: {
        navBar,
        couponItem,
    },
    data() {
        return {
            refreshing: false,
            showMore: false,
            myCouponList: [],
            reCommendList: [],
            pageMenu: []
        }
    },
    created () {
        this.getData();
        let pageMenu = JSON.parse(localStorage.getItem('setTempConfigs')).pageEnd
        this.pageMenu = pageMenu.menuList;
    },
    methods: {
        getData() {
            this.refreshing = false;
            let Coupon ={
              branchIsolation: !!localStorage.getItem('coupon_organ_insulate')
            }
          
            // 已领取
            this.$api.account.getUserCouponList(Coupon).then((res)=>{
                if(res.success) {
                    this.myCouponList = res.data;
                }
            })
            // 未领取
            this.$api.account.getCouponList(Coupon).then((res)=>{
                if(res.success) {
                    this.reCommendList = res.data;
                }
            })
        },
        handleUse(data) {
            const {goodsId, ucode, isApplyGoodsType} = data;
            this.$api.account.useCoupon({
                couponId: data.id,
            }).then((res)=>{
                if(res.success) {
                    if (data.jumpUrl) {
                        this.$router.push({
                            path: data.jumpUrl
                        });
                    } else {
                      if(isApplyGoodsType == 1) {
                        // 全部商品可用跳站点
                        let stationCof = this.pageMenu.find((v) => {
                          return v.name == '课程中心'
                        })
                        let path = stationCof.url
                        if (path) {
                          this.$router.push(path)
                        } else {
                          window.location.href= window.location.protocol+'//'+window.location.host;
                        }
                      } else {
                          if(data.goodsId) {
                              // 只有一个商品跳详情
                              if(data.goodsKinds == 1 || data.goodsKinds == 2) {
                                  this.$router.push(`/goodsDetail?goodsId=${goodsId}&goodsKind=${data.goodsKinds}`)
                              } else if(data.goodsKinds == 3) {
                                  this.$router.push(`/entityGoodsDetail?goodsId=${goodsId}&goodsKind=3`)
                              }
                          } else {
                              // 列表
                              this.$router.push(`/couponGoodsList?ucode=${ucode}`)
                          }
                      }
                    }
                } 
            })
        },
        getCoupon(ucode) {
            this.$api.account.getCoupon({
                ucode,
            }).then((res)=>{
                if(res.success) {
                    const result = this.reCommendList.filter(v=>v.ucode == ucode);
                    const index = this.reCommendList.findIndex(v=>v.ucode == ucode);
                    if(index>-1) {
                        this.reCommendList.splice(index,1)
                        this.myCouponList.unshift(result[0]);
                    }

                    this.getData();
                    return Toast('领取成功')
                } 
                Toast(res.message || '领取失败')
            })
        },
        onRefresh() {
            this.getData();
        },
        onClickLeft() {
            if(this.$route.query.backPath){
                this.$router.replace({
                    path: this.$route.query.backPath
                });
            }else{
                if(this.isNewSaas){
                    this.$router.push('/personalCenter_new');
                }else{
                    // this.$router.push('/saccount');
                    this.$router.push('/personal');
                }   
            }
        },
    },
}
</script>
<style lang="less" scoped>
    ::v-deep {
        .van-pull-refresh {
            min-height: 100vh;
        }
    }
    .coupon-list-page {
        min-height: 100vh;
        background-color: #fff;
        .empty-box{
            padding-top: 160px;
        }
        .main {
            padding-top: 40px;
        }
        .list-box {
            padding: 0 32px 32px;
            border-bottom: 16px solid #F8FAFC;
            &.noborder {
                border-bottom: 0 none;
            }
            .coupon-item {
                &:last-of-type {
                    margin-bottom: 0;
                }
            }
            .hidden {
                max-height: 712px;
                overflow: hidden;
            }
            &:last-of-type {
                border: 0 none;
            }
            .more-box {
                text-align: center;
                font-size: 24px;
                color: #999;
                padding: 32px 0 0;
                .icon {
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    background: url('../asset/images/icon_down.png') no-repeat center center /100% 100%;
                    &.up {
                        background: url('../asset/images/icon_up.png') no-repeat center center /100% 100%;
                    }
                }

            }
        }
        .title {
            text-align: center;
            padding: 38px 0;
            .text {
                position: relative;
                font-size: 36px;
                line-height: 50px;
                color: #333;
                display: inline-block;
                font-weight: 500;
                &::before,&::after {
                    content: '';
                    width: 45px;
                    height: 20px;
                    background-color: #f00;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    background: url(../asset/images/title_icon.png) no-repeat center center /100% 100%;
                }
                &::before{
                    left: -78px;
                } 
                &::after {
                    right: -78px;
                }
            }
            
        }
    }
</style>